
// Authentication

export const LOGIN_POST_REQUEST= "LOGIN_POST_REQUEST";
export const LOGIN_POST_SUCCESS= "LOGIN_POST_SUCCESS";
export const LOGIN_POST_FAILURE= "LOGIN_POST_FAILURE";
export const REGISTER_POST_SUCCESS= "LOGIN_POST_SUCCESS";


// Products

export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
export const PRODUCT_FAILURE ="PRODUCT_FAILURE";
export const GET_PRODUCT_SUCCESS= "GET_PRODUCT_SUCCESS";
